import {
  HerzliyaLoginStepFormFieldsEnum,
  yupLanding,
} from "@ryde/utils-landings";

export const yupLoginLandingHerzliyaValidationSchema = {
  [HerzliyaLoginStepFormFieldsEnum.FirstName]: yupLanding.string().required(),
  [HerzliyaLoginStepFormFieldsEnum.lastName]: yupLanding.string().required(),
  [HerzliyaLoginStepFormFieldsEnum.Phone]: yupLanding.string().required(),
  [HerzliyaLoginStepFormFieldsEnum.AcceptTerms]: yupLanding
    .boolean()
    .required(),
};
